import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Comments } from '../entities/comments.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CommentsService {
    readonly BASE: any = PETICIONES.comments;

    constructor(private http: HttpClient) { }

    /**
    * @description
    * Obtiene todos los cas
    */
    public findAll(): Observable<any> {
        return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene un comments por su id
    */
    public findById(id: number): Observable<any> {
        let idCas: string = (id !== undefined && id !== null ? id + "" : "");
        return this.http.get(this.BASE.findById + "/" + idCas).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene una lista de comments por su code
    */
    public findByCode(users: string): Observable<any> {
        let userscomments: string = (users !== undefined && users !== null ? users + "" : "");
        return this.http.get(this.BASE.findByUsers + "/" + userscomments).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene una lista de comments por su code
    */
    public findByUsername(username: string): Observable<any> {
        let usernamecomments: string = (username !== undefined && username !== null ? username + "" : "");
        return this.http.get(this.BASE.findByUsername + "/" + usernamecomments).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene una lista de comments por su dboid
    */
    public findByDboid(dboid: string, filas: number): Observable<any> {
        let dboidcomments: string = (dboid !== undefined && dboid !== null ? dboid + "" : "");
        let filascomments: number | null = (filas != null ? filas : null);
        return this.http.get(this.BASE.findByDboid + "/" + dboidcomments + "/" + filascomments).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene una lista de comments por su nif y id de receptor
    */
    public findByUserNif(user: string, nif: string, usuario: any): Observable<any> {
        let usercomments: string = (user !== undefined && user !== null ? user + "" : "");
        let nifcomments: string = (nif !== undefined && nif !== null ? nif + "" : "");
        let usuariocomments: string = (usuario !== undefined && usuario !== null ? usuario + "" : "");
        return this.http.get(this.BASE.findByUserNif + "/" + usercomments + "/" + nifcomments + "/" + usuariocomments).pipe(delay(DELAY));
    }


    /**
    * @description
    * Guarda un comment en la base de datos
    */
    public postComments(commets: Comments): Observable<any> {
        const json = JSON.stringify(commets);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postComments, json, {headers: headers}).pipe(delay(DELAY));
    }

    /**
    * @description
    * Borra un comment en la base de datos
    */
    public deleteComments(comments: Comments): Observable<any> {
        let idComments: string = (comments.id !== undefined && comments.id !== null ? comments.id + "" : "");
        return this.http.get(this.BASE.deleteComments + "/" + idComments).pipe(delay(DELAY));
    }
}